<script setup lang="ts">
registerSquircleWorklet();

// Not used currently
// useInjectAppDynamicsAgent();

useAppsFlyerSmartBanner();
</script>

<template>
  <NuxtLayout>
    <NuxtLoadingIndicator
      color="repeating-linear-gradient(to right,#00CCD6 0%,#110C30 100%)"
    />
    <NuxtPage />
  </NuxtLayout>
</template>
